{
  "occupationToClassification": {
    "Leader": "Independent",
    "Company Representative": "Non-Executive",
    "Senior Vice President": "Executive",
    "CEO": "Executive",
    "Chairman - Co-CEO": "Executive",
    "Co-CEO": "Executive",
    "Chief Information Officer": "Executive",
    "Chief Operating Officer": "Executive",
    "Corporate Secretary": "Executive",
    "Chairman-Interim CEO": "Executive",
    "President": "Executive",
    "Co-Chairman - CEO": "Executive",
    "Co-Chairman - Co-CEO": "Executive",
    "Executive Vice President": "Executive",
    "Chairman-CEO": "Executive",
    "Interim CEO": "Executive",
    "Vice President": "Executive",
    "Accounting Director": "Executive",
    "Marketing Director": "Executive",
    "Sales Director": "Executive",
    "Chief Governance Officer": "Executive",
    "H.R. Director": "Executive",
    "Interim Chairman-CEO": "Executive",
    "Chief Risk Officer": "Executive",
    "Chief Technology Officer": "Executive",
    "Chief Compliance Officer": "Executive",
    "Employee Representative": "Executive",
    "CFO": "Executive"
  }
}
